import React, { useState, useEffect } from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { request } from 'meinian-package/src/utils'
import { CommonInspirationBaseCard } from '../../workbench/commonInspiration'
import BaseDrawer from '../baseDrawer'
import styles from './index.module.less'

const PastDrawer = ({ onClose, visible, params, title }) => {
  const [data, setData] = useState<any>([])

  const fetchData = async () => {
    const result:any = await request.post('/zhikuan/ins/inspiration/list-inspiration-style', {
      start: 0,
      pageSize: 10,
      ...params,
    })
    setData(result.resultList)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return <BaseDrawer
    onClose={onClose}
    width={440}
    visible={visible}
    title={`往期「${title}」`}
  >
    <div className={styles.pastDrawerListWrap}>
      {data?.map(item => <CommonInspirationBaseCard
        itemData={item}
        className={classNames(styles.officialPastItem, 'fill-white-bg')}
        onClick={() => {
          window.open(`/meinian/home/coll/detail/${item.shareUrl}?shareUrl=${item.shareUrl}`)
        }}
      />)}
    </div>
  </BaseDrawer>
}

export default ({ queryType, title }) => { // 官方灵感集往期推荐
  const [visible, setVisible] = useState(false)
  return <>
    <Button
      type="normal"
      style={{ padding: '2px 8px', marginLeft: '24px', fontSize: '14px', fontWeight: 400 }}
      onClick={() => setVisible(true)}
    >查看往期<Icon type="m-Vxing_you" /></Button>
    {
      visible && <PastDrawer
        params={{
          queryType
        }}
        title={title}
        visible={visible}
        onClose={() => setVisible(false)}
      />
    }
  </>
}
